import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useTheme, ThemeToggle } from "@/context/theme";
import axios from "axios";
import { API, apiErrorMessage } from "@/lib/api";
import { Btn, Input, Field } from "@/components/ui-rp";
import { StatusFooter } from "@/components/StatusFooter";

export default function ResetPassword() {
  const { t } = useI18n();
  const { theme } = useTheme();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (pw !== pw2) { setError(t("reset.mismatch")); return; }
    setBusy(true);
    try { await axios.post(`${API}/auth/reset-password`, { token, password: pw }); setDone(true); }
    catch (err) { setError(apiErrorMessage(err, t("common.error"))); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10 bg-background text-foreground">
      <img src={theme === "dark" ? "/logos/rapidpay-white.png" : "/logos/rapidpay-color.webp"} alt="RapidPay" className="h-10 mb-8" />
      <div className="w-full max-w-md rounded-2xl shadow-lg p-6 sm:p-8 bg-card border border-border" data-testid="reset-password-page">
        <h1 className="font-heading text-xl sm:text-2xl font-bold tracking-tight mb-1">{t("reset.title")}</h1>
        <p className="text-sm mb-6 text-muted-foreground">{done ? t("reset.done") : t("reset.help")}</p>
        {done ? <Btn onClick={() => navigate("/cuenta")} testId="reset-go-login" className="w-full h-12">{t("login.signIn")}</Btn> : (
          <form onSubmit={submit} className="space-y-4">
            <Field label={t("reset.newPassword")}><Input testId="reset-password-input" type="password" autoComplete="new-password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} /></Field>
            <Field label={t("reset.confirm")}><Input testId="reset-password-confirm" type="password" autoComplete="new-password" minLength={8} required value={pw2} onChange={(e) => setPw2(e.target.value)} /></Field>
            {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
            <Btn type="submit" busy={busy} disabled={!token} testId="reset-submit" className="w-full h-12 text-base">{t("reset.submit")}</Btn>
          </form>
        )}
        <div className="mt-6 pt-4 border-t border-border flex justify-end"><ThemeToggle /></div>
      </div>
      <StatusFooter className="w-full max-w-md mt-6 border-t-0 pt-0" />
    </div>
  );
}
